/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Great_Early_Crossbill_EmbraceInputs */

const fr_great_early_crossbill_embrace = /** @type {(inputs: Great_Early_Crossbill_EmbraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un cours`)
};

/**

* @param {Great_Early_Crossbill_EmbraceInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const great_early_crossbill_embrace = /** @type {((inputs?: Great_Early_Crossbill_EmbraceInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Great_Early_Crossbill_EmbraceInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_great_early_crossbill_embrace(inputs)
});